module.exports = __webpack_public_path__ + "static/img/slide_3_fr.2deaef4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/live-hr-advice/slider/slide_3_fr.png
// module id = hdb0
// module chunks = 0